module.exports = __webpack_public_path__ + "img/f-02.7e23304c.jpg";